module.exports = __webpack_public_path__ + "img/calculator.1aca91c3.png";